import React from 'react';
import { Link } from 'react-router-dom';
import HeroImg from '../../assets/images/hero-img.png';
export default function Hero() {
  return (
    <div
      className={
        'h-screen px-5 lg:px-28 lg:pt-5 py-10 flex flex-col lg:flex-row items-center'
      }
    >
      <div className={'w-full lg:w-1/2'}>
        <div>
          <h3
            className={
              'text-4xl lg:text-7xl text-center lg:text-left font-extralight'
            }
          >
            Simplify your
          </h3>
          <h3
            className={
              'text-4xl lg:text-7xl text-center lg:text-left font-semibold text-yellow-500 leading-none'
            }
          >
            Rewards Program
          </h3>
          <div className={'mt-3'}>
            <p
              className={
                'font-light text-center lg:text-left text-base lg:text-3xl'
              }
            >
              We help you make the process of disbursing airtime, data, e-money
              and gift cards quicker and faster.
            </p>
          </div>
        </div>
        <div
          className={
            'flex flex-row justify-center lg:justify-start items-center mt-10'
          }
        >
          <Link to={'/register'}>
            <span
              className={
                'shadow-xl bg-yellow-500 text-white border-2  border-yellow-500  rounded px-5 py-3'
              }
            >
              Get started
            </span>
          </Link>
          <Link to={'/login'}>
            <span
              className={
                'shadow-xl bg-white text-yellow-500 border-2 border-yellow-500 rounded px-5 py-3 ml-5'
              }
            >
              Login to account
            </span>
          </Link>
        </div>
      </div>
      <div
        className={
          ' mt-8 lg:m-0 w-full lg:w-1/2 px-8 flex justify-center items-center'
        }
      >
        <img alt={''} src={HeroImg} className={'w-4/5'} />
      </div>
    </div>
  );
}
